import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { BehaviorSubject, timer } from 'rxjs';
import { catchError, of, switchMap } from 'rxjs';

export interface MaintenanceStatus {
  scheduled: boolean;
  startTime: string;
  endTime: string;
  message: string;
}

const POLL_INTERVAL_MS = 60_000;

@Injectable({ providedIn: 'root' })
export class MaintenanceStatusService {
  private readonly status$ = new BehaviorSubject<MaintenanceStatus | null>(
    null
  );
  readonly maintenanceStatus$ = this.status$.asObservable();

  constructor(private http: HttpClient) {
    // The subscription is intentionally kept alive for the full app lifetime.
    // providedIn: 'root' services are never destroyed by Angular's injector,
    // so ngOnDestroy would never fire here — polling is expected to run always.
    timer(0, POLL_INTERVAL_MS)
      .pipe(
        switchMap(() =>
          this.http
            .get<MaintenanceStatus>('/maintenance.json', {
              headers: { 'Cache-Control': 'no-cache' },
            })
            .pipe(catchError(() => of(null)))
        )
      )
      .subscribe((status) => this.status$.next(status));
  }
}
